import store from "../../app/store";
import { createAction } from "@reduxjs/toolkit";
import {
    ACTION_TARGET_TYPES_CHANGED,
    ACTION_TARGET_TYPES_LOADING_CHANGED
} from "./MsbPageReducer";

export function loadTargetTypesToRedux(targetTypes) {
    store.dispatch(createAction(ACTION_TARGET_TYPES_CHANGED)({
        targetTypes,
        targetTypesLoading: false
    }))
}

export function setTargetTypesLoading(isLoading) {
    store.dispatch(createAction(ACTION_TARGET_TYPES_LOADING_CHANGED)({ targetTypesLoading: isLoading }))
}
